import type { VaultMediaType } from '@api'

import type { Media } from '@/modules/chatting/types'

export const getMediaTypes = (media: Media[]): VaultMediaType[] => {
  const types = new Set<VaultMediaType>()

  media.forEach((media) => {
    types.add(media.type)
  })

  return Array.from(types)
}
